import React, { HTMLProps, MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './ListItem.module.scss';

export const ListItem = ({
    children, className, bordered,
    active, onClick, ...props
}: Props) => {

    const classes = classNames(className, styles.default, {
        [styles.bordered]: bordered,
        'idt-active': active,
        'idt-inactive': !active
    });

    return (
        <div onClick={onClick} className={classes} {...props}>
            {children}
        </div>
    );
};

type Props = HTMLProps<HTMLDivElement> & PropsWithChildren<{
    onClick: MouseEventHandler;
    className?: string;
    active?: boolean;
    bordered?: boolean;
}>;